import { EAnoNe } from 'enums/anoNe';

const c5PepSelect = [
    {
        value: EAnoNe.ANO,
        labelcz: 'FORMULARE_AMLZ_C5_SELECT_ANO'
    },
    {
        value: EAnoNe.NE,
        labelcz: 'FORMULARE_AMLZ_C5_SELECT_NE'
    }
];

export default c5PepSelect;
